import Link from "next/link";
import { FaTwitter } from "react-icons/fa";
import { SocialLinks } from "~/types/UserTypes";
import { slugifyUser } from "~/utils/string";
import UserImage from "./UserImage";
import { cn } from "~/utils/fontsConfig";
import { AnyUser } from "~/types/UserTypesInferred";

type Props = {
    user: AnyUser;
    className?: string;
};

const UserLink = (props: Props) => {
    if (!props.user) return null;

    const twitterLink =
        "socialLinks" in props.user &&
        ((props.user.socialLinks as SocialLinks)?.x as string);

    if (!props.user) return null;

    return (
        <div
            className={`mt-2 flex flex-row items-center justify-between gap-1`}
        >
            <Link
                className="group flex cursor-pointer flex-row"
                href={`/profile/${slugifyUser(props.user)}`}
            >
                <UserImage user={props.user} iconSize={40} />
                <div
                    className={cn(
                        `ml-2 flex max-w-[160px] flex-row 
                    items-center transition-[color] duration-300 group-hover:text-secondary
                `,
                        props.className,
                    )}
                >
                    <p className="line-clamp-1">{props.user.name}</p>
                </div>
            </Link>

            {(twitterLink as string) && (
                <button
                    className={`transition-[color] duration-300 hover:text-secondary`}
                    onClick={() => {
                        window.open(`${twitterLink}`, "_blank");
                    }}
                >
                    <FaTwitter />
                </button>
            )}
        </div>
    );
};

export default UserLink;
